// extracted by mini-css-extract-plugin
export default {"searchBtn":"SearchButton_searchBtn__5mtAP","slideUp":"SearchButton_slideUp__3O85P","slideDown":"SearchButton_slideDown__D-BGL"};